import { render, staticRenderFns } from "./ModalRegistrationRecommendCompany.vue?vue&type=template&id=753dc0c8&"
import script from "./ModalRegistrationRecommendCompany.vue?vue&type=script&lang=js&"
export * from "./ModalRegistrationRecommendCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports